// extracted by mini-css-extract-plugin
export default {"container":"borku_container__ojApH","aboutSec":"borku_aboutSec__KM0Gu"};